const LanguageEnum = Object.freeze({
  Ukrainian: 1,
});

export default (LanguageEnum);
